module.exports = __webpack_public_path__ + "img/hqw_logo.e26278b0.png";